import { useMemo } from 'react';
import { EditorOptions } from '@tiptap/core';
import { Bold } from '@tiptap/extension-bold';
import { Link } from '@tiptap/extension-link';
import { Text } from '@tiptap/extension-text';
import { Placeholder } from '@tiptap/extensions';
import { Italic } from '@tiptap/extension-italic';
import { Strike } from '@tiptap/extension-strike';
import { LinkBubbleMenuHandler } from 'mui-tiptap';
import { History } from '@tiptap/extension-history';
import { Heading } from '@tiptap/extension-heading';
import { Document } from '@tiptap/extension-document';
import { ListItem } from '@tiptap/extension-list-item';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Underline } from '@tiptap/extension-underline';
import { Highlight } from '@tiptap/extension-highlight';
import { Gapcursor } from '@tiptap/extension-gapcursor';
import { HardBreak } from '@tiptap/extension-hard-break';
import { TextAlign } from '@tiptap/extension-text-align';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { BulletList } from '@tiptap/extension-bullet-list';
import { ListKeymap } from '@tiptap/extension-list-keymap';
import { OrderedList } from '@tiptap/extension-ordered-list';

import { IndentExtension, ResizableImageWithAlign } from './extensions';

const CustomLinkExtension = Link.extend({
  inclusive: false,
});

export const useExtensions = (
  allowImages = true,
  placeholder = ''
): EditorOptions['extensions'] => {
  return useMemo(() => {
    return [
      Document,
      Text,
      Bold,
      Paragraph,
      ...(placeholder
        ? [Placeholder.configure({ placeholder, showOnlyCurrent: false })]
        : []),
      HardBreak,
      Italic,
      History,
      Heading,
      Underline,
      Strike,
      TextAlign.configure({
        types: ['heading', 'paragraph', ...(allowImages ? ['image'] : [])],
      }),
      ...(allowImages ? [ResizableImageWithAlign] : []),
      Gapcursor,
      Dropcursor,
      Highlight.configure({
        multicolor: true,
      }),
      ListItem,
      BulletList.configure({
        keepMarks: true,
        keepAttributes: true,
      }),
      OrderedList.configure({
        keepMarks: true,
        keepAttributes: true,
      }),
      ListKeymap,
      CustomLinkExtension.configure({
        autolink: true,
        linkOnPaste: true,
        openOnClick: false,
      }),
      LinkBubbleMenuHandler,
      IndentExtension,
    ];
  }, [allowImages, placeholder]);
};
